/**
 * Created by slava on 7/11/17
 */

const Boatswain = function (level) {
    this.level = level;

    this.setIntent(Boatswain.RETURN_INTENT);
};

Boatswain.prototype.setIntent = function (intent, options) {
    this.intent = intent;
    this.intentOptions = options || {};
};

Boatswain.prototype.playIntent = function (f) {
    const missionWithIntent = cleverapps.missionManager.getMissionWithIntent();

    switch (this.intent) {
        case Boatswain.NEXT_INTENT:
            Level.WantsToPlay(f, this.intentOptions);
            break;

        case Boatswain.REPLAY_INTENT:
            Level.WantsToPlay(f, {
                level: this.level
            });
            break;

        case Boatswain.RETURN_INTENT:
            if (cleverapps.playButton && cleverapps.playButton.playedFromLocationId) {
                const locationId = cleverapps.playButton.playedFromLocationId;
                delete cleverapps.playButton.playedFromLocationId;
                cleverapps.silentIntro = true;
                cleverapps.meta.switchLocation(locationId);
                cleverapps.meta.gotoLocationScene(f);
            } else if (this.level.isDailyCup()) {
                cleverapps.scenes.replaceScene(bundles.main.jsons.dailycupscene_prefab_json, f);
            } else if (this.level.isWeeklyTournamentLevel()) {
                cleverapps.scenes.replaceScene(bundles.main.jsons.weeklytournamentscene_prefab_json, f);
            } else if (missionWithIntent && missionWithIntent.logic.willUseIntent(this.level)) {
                missionWithIntent.useMissionIntent(f);
            } else {
                cleverapps.meta.gotoMainLocation(f);
            }
    }
};

const BoatswainAction = function (f) {
    this.game.boatswain.playIntent(f);
};

Boatswain.RETURN_INTENT = 0;
Boatswain.NEXT_INTENT = 1;
Boatswain.REPLAY_INTENT = 2;
